import React, { useState } from 'react';
import { CgClose } from "react-icons/cg";
import { FaCloudUploadAlt } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import uploadImage from '../helpers/uploadImage';
import SummaryApi from '../common';
import { toast } from 'react-toastify';

const UploadCategory = ({ onClose, fetchData }) => {
  const [data, setData] = useState({
    categoryName: "",
    image: "",
    subCategories: [],
  });

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleUploadImage = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const uploadImageCloudinary = await uploadImage(file);
    setData((prev) => ({ ...prev, image: uploadImageCloudinary.url }));
  };

  const handleDeleteImage = () => {
    setData((prev) => ({ ...prev, image: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch(SummaryApi.uploadCategory.url, {
      method: SummaryApi.uploadCategory.method,
      credentials: 'include',
      headers: { "content-type": "application/json" },
      body: JSON.stringify(data),
    });
    
    const responseData = await response.json();
    if (responseData.success) {
      toast.success(responseData.message);
      onClose();
      fetchData();
    } else {
      toast.error(responseData.message);
    }
  };

  return (
    <div className='fixed w-full h-full bg-slate-200 bg-opacity-35 top-0 left-0 flex justify-center items-center'>
      <div className='bg-white p-4 rounded w-full max-w-md'>
        <div className='flex justify-between items-center pb-3'>
          <h2 className='font-bold text-lg'>Add Category</h2>
          <CgClose className='text-2xl cursor-pointer hover:text-red-600' onClick={onClose} />
        </div>

        <form className='grid gap-2' onSubmit={handleSubmit}>
          <label htmlFor='categoryName'>Category Name:</label>
          <input
            type='text'
            id='categoryName'
            name='categoryName'
            value={data.categoryName}
            onChange={handleOnChange}
            className='p-2 bg-slate-100 border rounded'
            required
          />

          <label htmlFor='image'>Category Image:</label>
          <label htmlFor='uploadImageInput' className='cursor-pointer'>
            <div className='p-2 bg-slate-100 border rounded h-32 flex justify-center items-center'>
              {data.image ? (
                <div className='relative group'>
                  <img src={data.image} alt='Category' className='h-24 w-24 object-cover' />
                  <MdDelete className='absolute top-0 right-0 text-white bg-red-600 p-1 rounded-full cursor-pointer' onClick={handleDeleteImage} />
                </div>
              ) : (
                <div className='text-slate-500 flex flex-col items-center'>
                  <FaCloudUploadAlt className='text-4xl' />
                  <p className='text-sm'>Upload Image</p>
                  <input type='file' id='uploadImageInput' className='hidden' onChange={handleUploadImage} />
                </div>
              )}
            </div>
          </label>

          <button className='px-3 py-2 bg-blue-600 text-white hover:bg-blue-700'>Upload Category</button>
        </form>
      </div>
    </div>
  );
};

export default UploadCategory;
